import { gql } from '@apollo/client';

export const GET_NOISE_EVENTS_BY_ALERT_ID_BASE = gql(`
  query GetNoiseEventsByAlertIdBase($filter: GuidIdInFilter) {
    facility {
      alerts {
        noiseEvents(filter: $filter) {
          id
        }
      }
    }
  }
`);
